<template>
  <div class="container">
    <div class="sobre container">
      <div class="text-center justify-content-center">
        <h2 class="text-primary pt-5 col-12 titulo">Planifica tu cita, planifica tu tiempo<br>Talleres autorizados KIA</h2>
        <img src="@/assets/images/Home_colisiones_web.jpg" alt="imagen_citas" class="imagen img-fluid">
        <div class="justify-content-center pt-5">
          <button class="btn btn-primary col-md-5 boton m-2 btn-pill" type="button" v-on:click="consultaColicion">Consulta colisiones</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Home",
    data: () => ({
      valor:{},
    }),
    methods:{
      consultaColicion:function(){
        this.$router.push({name:"p1"});
      },
    },
    created() {
      this.$store.commit('setActual', null);
      this.$store.commit('limpiar');
    },
  }
</script>
<style scoped>
  .sobre{
    z-index: 500;
    position: inherit;
  }
  .imagen{
    max-height: 450px;
  }
</style>
